module.exports = __webpack_public_path__ + "img/182.5fc3a5dd.jpg";